import React from 'react';
import ArrowIcon from 'assets/svgs/actions/arrow.svg';

const Breadcrumb = ({list, onClick, tab, setSelectedTab}) => (
  <div className="d-flex bg-gray4 breadcrumb-custom border w-100">
    <div
      aria-hidden
      className="d-flex align-items-center px-2 pointer"
      onClick={() => {
        onClick(null);
        setSelectedTab(null);
      }}
    >
      Documents
      <img
        alt=""
        src={ArrowIcon}
        height={15}
        className={`ml-2 ${list.length === 0 && !tab ? 'rotate' : ''}`}
      />
    </div>

    {tab && (
      <div
        aria-hidden
        className="d-flex align-items-center px-2 pointer"
        onClick={() => onClick(null)}
      >
        {tab}
        <img
          alt=""
          src={ArrowIcon}
          height={15}
          className={`ml-2 ${list.length === 0 ? 'rotate' : ''}`}
        />
      </div>
    )}

    {list.map((folder, index) => (
      <div
        aria-hidden
        key={folder._id}
        className={`d-flex align-items-center px-2 ${
          index === list.length - 1 ? '' : 'pointer'
        } `}
        onClick={() => onClick(folder)}
      >
        {folder.name}
        <img
          alt=""
          src={ArrowIcon}
          height={15}
          className={`ml-2 ${index === list.length - 1 ? 'rotate' : ''}`}
        />
      </div>
    ))}
  </div>
);

export default Breadcrumb;
